import React from 'react';
import { AppBundle } from 'api/optimalprint-sdk.d';
import { useSelector } from 'react-redux';
import getSelectedBundleProducts from 'store/product/selector/getSelectedBundleProducts';
import getSelectedBundleItems from 'utils/bundles/getSelectedBundleItems';
import { Price } from 'components/Common';
import getCategoryId from 'store/category/selector/getCategoryId';
import styles from './SelectedBundleProducts.module.scss';

interface Props {
  bundleGroup: AppBundle.Api.Entity.Design.V1.DesignAbstractProduct.DesignProductItem.IBundleGroup;
}

const SelectedBundleProducts = ({ bundleGroup }: Props) => {
  const allSelectedProducts = useSelector(getSelectedBundleProducts);
  const categoryId = useSelector(getCategoryId);

  const selectedProducts = allSelectedProducts
    .filter((sp) => sp.bundleGroupId === bundleGroup.bundleGroupId)
    .map((sp) => sp.productId);
  if (selectedProducts.length === 0) {
    return null;
  }
  const selectedProductsWithNames = getSelectedBundleItems(bundleGroup, selectedProducts);

  return (
    <div className={styles.selectedProducts}>
      {selectedProductsWithNames?.map((product) => (
        <div className={styles.selectedProduct}>
          <span>{product.name}</span>
          <span className={styles.price}>
            <Price categoryId={categoryId || 1} productId={product.productId || 1} />
          </span>
        </div>
      ))}
    </div>
  );
};

export default SelectedBundleProducts;
